// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file maintenance_task.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file maintenance_task.proto.
 */
export const file_maintenance_task: GenFile = /*@__PURE__*/
  fileDesc("ChZtYWludGVuYW5jZV90YXNrLnByb3RvEgZkb21haW4qqwYKD01haW50ZW5hbmNlVGFzaxIcChhNQUlOVEVOQU5DRV9UQVNLX1VOS05PV04QABI5CjVNQUlOVEVOQU5DRV9UQVNLX09SR0FOSVpBVElPTl9QUkVMSU1JTkFSWV9QUk9GSUxFU19WMxAMEi4KKk1BSU5URU5BTkNFX1RBU0tfUFJPQ0VTU19WQVVMVF9NRVNTQUdFU19WMxAhEjQKME1BSU5URU5BTkNFX1RBU0tfRU5BQkxFX1BSRl9PUFBPUlRVTklTVElDQUxMWV9WMRAOEkQKQE1BSU5URU5BTkNFX1RBU0tfT1JHQU5JWkFUSU9OX1BFUkZPUk1fTUFJTlRFTkFOQ0VfSUZfRElTQUJMRURfVjEQEhIvCitNQUlOVEVOQU5DRV9UQVNLX09SR0FOSVpBVElPTl9FTlRSQV9TWU5DX1YyEB0SLQopTUFJTlRFTkFOQ0VfVEFTS19MRUFLRURfUEFTU1dPUkRfQ0hFQ0tfVjIQGxIpCiVNQUlOVEVOQU5DRV9UQVNLX1RFQU1fU1lOQ19NRU1CRVJTX1YzECMSMQotTUFJTlRFTkFOQ0VfVEFTS19URUFNX1NZTkNfTUVNQkVSU19CQUNLRU5EX1YzECQSNQoxTUFJTlRFTkFOQ0VfVEFTS19DUkVBVEVfREVMRUdBVEVEX0FETUlOU19WQVVMVF9WMhAfEiUKIU1BSU5URU5BTkNFX1RBU0tfTE9HSU5fU1VNTUFSWV9WMRAYEi0KKU1BSU5URU5BTkNFX1RBU0tfUEFTU1dPUkRfUE9MSUNZX0NIRUNLX1YyEBwSOAo0TUFJTlRFTkFOQ0VfVEFTS19NSUdSQVRFX1BBU1NLRVlfRklETzJfRVhURU5TSU9OU19WMRAiIgQIARABIgQIAhACIgQIAxADIgQICRAJIgQIERARIgQIBBAEIgQIBRAFIgQIChAKIgQIDRANIgQIDxAPIgQIBhAGIgQICxALIgQIBxAHIgQICBAIIgQIEBAQIgQIExATIgQIFBAUIgQIFRAVIgQIFhAWIgQIIBAgIgQIGRAZIgQIHhAeIgQIFxAXIgQIGhAaQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * * This is an enum of maintenance tasks, which map to tasks perfomed by client-core. They are
 * included in SyncUpdate as an allow list, serving as a "killswitch" for disabling outdated or
 * rogue maintenance tasks, independently of the release cycle.
 *
 * The two common expected changes are:
 * 1) Deprecating a task altogether. To do this, comment it out and mark the field number as
 * reserved.
 * 2) Creating a new "version" of a task, while disabling the previous. To do this, increase the
 * field number, mark the old field number as reserved, and increase the VX number in the name.
 *
 * @generated from enum domain.MaintenanceTask
 */
export enum MaintenanceTask {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: MAINTENANCE_TASK_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: MAINTENANCE_TASK_ORGANIZATION_PRELIMINARY_PROFILES_V3 = 12;
   */
  ORGANIZATION_PRELIMINARY_PROFILES_V3 = 12,

  /**
   * @generated from enum value: MAINTENANCE_TASK_PROCESS_VAULT_MESSAGES_V3 = 33;
   */
  PROCESS_VAULT_MESSAGES_V3 = 33,

  /**
   * @generated from enum value: MAINTENANCE_TASK_ENABLE_PRF_OPPORTUNISTICALLY_V1 = 14;
   */
  ENABLE_PRF_OPPORTUNISTICALLY_V1 = 14,

  /**
   * Special maintenance task to allow switching off maintenance of disabled orgs. 
   *
   * @generated from enum value: MAINTENANCE_TASK_ORGANIZATION_PERFORM_MAINTENANCE_IF_DISABLED_V1 = 18;
   */
  ORGANIZATION_PERFORM_MAINTENANCE_IF_DISABLED_V1 = 18,

  /**
   * @generated from enum value: MAINTENANCE_TASK_ORGANIZATION_ENTRA_SYNC_V2 = 29;
   */
  ORGANIZATION_ENTRA_SYNC_V2 = 29,

  /**
   * @generated from enum value: MAINTENANCE_TASK_LEAKED_PASSWORD_CHECK_V2 = 27;
   */
  LEAKED_PASSWORD_CHECK_V2 = 27,

  /**
   * @generated from enum value: MAINTENANCE_TASK_TEAM_SYNC_MEMBERS_V3 = 35;
   */
  TEAM_SYNC_MEMBERS_V3 = 35,

  /**
   * @generated from enum value: MAINTENANCE_TASK_TEAM_SYNC_MEMBERS_BACKEND_V3 = 36;
   */
  TEAM_SYNC_MEMBERS_BACKEND_V3 = 36,

  /**
   * @generated from enum value: MAINTENANCE_TASK_CREATE_DELEGATED_ADMINS_VAULT_V2 = 31;
   */
  CREATE_DELEGATED_ADMINS_VAULT_V2 = 31,

  /**
   * @generated from enum value: MAINTENANCE_TASK_LOGIN_SUMMARY_V1 = 24;
   */
  LOGIN_SUMMARY_V1 = 24,

  /**
   * @generated from enum value: MAINTENANCE_TASK_PASSWORD_POLICY_CHECK_V2 = 28;
   */
  PASSWORD_POLICY_CHECK_V2 = 28,

  /**
   * Clients from 2026-03-25 up to the first release with this task store fido2Extensions from CXF
   * imports verbatim. Remove this task once the minimum client version excludes them, plus a grace
   * period for the remaining passkeys to be migrated. The parse-time handling of
   * unmigratedFido2Extensions in persistable-types must stay, e.g. for history revisions.
   *
   * @generated from enum value: MAINTENANCE_TASK_MIGRATE_PASSKEY_FIDO2_EXTENSIONS_V1 = 34;
   */
  MIGRATE_PASSKEY_FIDO2_EXTENSIONS_V1 = 34,
}

/**
 * Describes the enum domain.MaintenanceTask.
 */
export const MaintenanceTaskSchema: GenEnum<MaintenanceTask> = /*@__PURE__*/
  enumDesc(file_maintenance_task, 0);

